import { createFileRoute } from '@tanstack/react-router'

import DetaiPenyuluhPusatPage from '@/components/pages/backoffice/_klb-penyuluh/_pusat/_$pusatId/containers/DetailPenyuluhProvinsiPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/pusat/$pusatId/'
)({
  component: DetaiPenyuluhPusatPage
})
